var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoInfoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#242424",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02953 0 0 4.02953 0 9C0 13.9705 4.02953 18 9 18C13.9705 18 18 13.9705 18 9C18 4.02953 13.9705 0 9 0ZM10.2387 13.6088C10.2387 13.9457 10.0774 14.034 9.81341 14.034H8.18616C7.92213 14.034 7.7609 13.9462 7.7609 13.6088V11.9815C7.7609 11.6441 7.92213 11.5563 8.18616 11.5563H9.81341C10.0774 11.5563 10.2387 11.6441 10.2387 11.9815V13.6088ZM9.86204 10.2233C9.81256 10.5812 9.78014 10.6226 9.40223 10.6226H8.59777C8.20365 10.6226 8.17081 10.5675 8.12175 10.2233C7.43204 4.7845 7.41583 4.74313 7.41583 4.70175C7.41583 4.46758 7.56341 4.41256 7.89185 4.41256H10.0919C10.4366 4.41256 10.5846 4.45393 10.5846 4.70175C10.5846 4.74313 10.568 4.7845 9.86204 10.2233Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInfoBlack);
export default __webpack_public_path__ + "static/media/ico-info-black.6b7977352121a3cc8a0b7c2035b5b184.svg";
export { ForwardRef as ReactComponent };